import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from 'app/core/services/config.service';
import { RequestService } from 'app/core/services/request.service';

@Injectable()
export class AddressCommonService {

  	constructor(
		private configService: ConfigService,
        private requestService: RequestService
	) { }

	delete(details: any): Observable<any> {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.communication.delete.api;
		return this.requestService.post(url, details);
	}
	edit(details: any): Observable<any> {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.communication.edit.api;
		return this.requestService.post(url, details);
	}
	add(details: any): Observable<any> {
		let url = this.configService.get('server').url + this.configService.get('endpoints').organization.address.addShippingAddress.api;
		return this.requestService.post(url, details);
	}
	getCountries(): Observable<any> {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.country.api;
		return this.requestService.get(url, {verbose: true, type: 'api'});
	}
	getDomains(): Observable<any> {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.domain.api;
		return this.requestService.get(url, {verbose: true, type: 'api'});
	}      
	getStatesByCountry(country: string): Observable<any> {
		let url = this.configService.get('server').sahara + this.configService.get('endpoints').sahara.dictionary.statesByCountry.api + '/' + country;
		return this.requestService.get(url, {verbose: true, type: 'api'});
	}
	getPatternCodeList(): Observable<any> {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.patternList.api;
		return this.requestService.get(url, {});
	}
	getCommunicationDetails(id: string): Observable<any> {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.communication.details.api + '/' + id;
		return this.requestService.get(url);
	}
	getPhoneNumberTypeDictionary(): Observable<any> {
		let url = this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.phoneNumberType.api;
		return this.requestService.get(url, {})
		.map(res => res.data);
	}
	getFields() {
		let fields = [
			{
				key: 'id',
				label: 'ID',
				type: 'hidden',
				required: false
			}, {
				key: 'firstName',
				label: 'First Name',
				type: 'textbox',
				required: false
			}, {
				key: 'lastName',
				label: 'Last Name',
				type: 'textbox',
				required: false
			}, {
				key: 'companyName',
				label: 'Company Name',
				type: 'textbox',
				required: false
			}, {
				key: 'streetName',
				label: 'Street Name',
				type: 'textbox',
				required: false
			}, {
				key: 'city',
				label: 'City',
				type: 'textbox',
				required: true
			}, {
				key: 'zipCode',
				label: 'Zip Code',
				type: 'textbox',
				required: false
			}, {
				key: 'houseNumber',
				label: 'House Number',
				type: 'textbox',
				required: false
			}, {
				key: 'state',
				label: 'State',
				type: 'textbox',
				required: false
			}, {
				key: 'province',
				label: 'Province',
				type: 'textbox',
				required: false
			}, {
				key: 'country.value',
				label: 'Country',
				type: 'combobox-single-select',
				required: true,
				dictionaryUrl:
					this.configService.get('server').url + this.configService.get('endpoints').agora.dictionary.country.api
			}, {
				key: 'extraInfo',
				label: 'Extra Info',
				type: 'textbox',
				required: false
			}, {
				key: 'email',
				label: 'Email',
				type: 'textbox',
				pattern: 'email',
				trim: true,
				required: false
			}
		];
		return fields;
	}

	getDetailsFields(country: string) {
		let fields = [
			{
				key: 'domain',
				label: 'Domain',
				type: 'text'
			}, {
				key: 'companyName',
				label: 'Company Name',
				type: 'text'
			}, {
				key: 'firstName',
				label: 'First Name',
				type: 'text'
			}, {
				key: 'lastName',
				label: 'Last Name',
				type: 'text'
			}, {
				key: 'streetName',
				label: 'Street Name',
				type: 'text'
			}, {
				key: 'houseNumber',
				label: 'House Number',
				type: 'text'
			},  {
				key: 'city',
				label: 'City:',
				type: 'text'
			}, {
				key: 'zipCode',
				label: 'Zip Code',
				type: 'text'
			}, {
				key: 'state',
				label: 'State',
				type: 'dictionary',
				dictionaryUrl:
					this.configService.get('server').sahara + this.configService.get('endpoints').sahara.dictionary.statesByCountry.api + '/' + country
			}, {
				key: 'country',
				label: 'Country',
				type: 'objectDictionary',
				dictionaryUrl:
					this.configService.get('server').url + 
					this.configService.get('endpoints').agora.dictionary.country.api
			}, {
				key: 'email',
				label: 'Email',
				type: 'text'
			}, {
				key: 'province',
				label: 'Province',
				type: 'text'
			}, {
				key: 'extraInfo',
				label: 'Extra Info',
				type: 'text'
			}, {
				key: 'phoneNumbers',
				label: 'Phone Numbers',
				type: 'table',
				config: [
					{
						title: 'Type',
						getter: (item) => {
							return item.type.configValue;
						}
					}, {
						title: 'Number',
						name: 'number'
					}, {
						title: 'Primary',
						name: 'primary',
						type: 'map',
						map: {
							true: 'Yes',
							false: 'No'
						}
					}
				]
			}
		];
		return fields;
	}

}



// WEBPACK FOOTER //
// ./src/app/organization/components/common/services/address-common.service.ts